/* eslint-disable react/require-default-props */
import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { BuyboxMessage } from '@thd-olt-component-react/buybox/dist/component/subcomponents/BuyboxMessage';
import proptypes from 'prop-types';

const { number } = proptypes;

export const BundleQuantityMessaging = ({ maxQuantity = 0, quantity }) => {
  const isTwoTileEnabledFS = useConfigService('isTwoTileEnabled');

  const showMaxQuantity = isTwoTileEnabledFS && maxQuantity && quantity >= maxQuantity;

  if (!showMaxQuantity) return null;

  return (
    <BuyboxMessage
      message={`This bundle has a limit of ${maxQuantity} per order`}
      status="warning"
    />
  );
};

BundleQuantityMessaging.propTypes = {
  maxQuantity: number,
  quantity: number.isRequired
};